/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Autocomplete,
} from '@mui/material';
import { toast } from 'react-toastify';
import Grid from '@mui/material/Unstable_Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import AppConst from '../AppLayout/const';
import { getDepartmentFilter, getRepFilter } from '../../api/filterOptionsApi';
// Helper Functions
import {
  filterValue,
  filterDepartmentOptions,
  filterRepOptions,
} from '../../helpers/filterFunctions';
import { postLocationLogReport } from '../../api/locationTrackerApi';

export default function LocationTrackerLogModal() {
  const { toggleModal, onToggleModal } = useContext(AppConst.AppContext);
  const [toggle, setToggle] = useState(false);

  const defaultFilter = {
    department: { label: 'ALL', value: '' },
    rep_id: { label: 'ALL', value: '' },
    date_from: moment().format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),
  };

  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [departmentOptions, setDepartmentDrowndown] = useState([]);
  const [repOptions, setRepOptions] = useState([]);

  const loadDepartmentDropdown = async () => {
    const request = {
      keyword: '',
    };
    const reponse = await getDepartmentFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterDepartmentOptions(data);

      setDepartmentDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadRepOptions = async () => {
    const request = {
      department: filterValue(filterForm?.department),
      team: [],
      date_from: filterForm?.date_from,
      date_to: filterForm?.date_to,
      month: [],
      years: [],
      keyword: '',
    };
    const response = await getRepFilter(request);
    const { code, data } = response.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);
      setRepOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  useEffect(() => {
    if (toggleModal?.url === 'report/location_traceker_log') {
      setToggle(true);
      loadDepartmentDropdown();
      loadRepOptions();
    }
  }, [toggleModal]);

  const handleExport = async () => {
    try {
      toast.loading('Please wait ...');
      const res = await postLocationLogReport({
        from: filterForm?.date_from,
        to: filterForm?.date_to,
        team: '',
        head_id: '',
        manager_id: '',
        rep_id: filterForm?.rep_id?.value,
        department: filterForm?.department?.value,
      });
      const { code, result, message } = res.data.response;
      if (code !== '200') {
        throw Object.assign(new Error(message), { code: 402 });
      }
      toast.dismiss();
      window.location.href = result;
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleSubmit = () => {
    handleExport();
  };

  const handleChangeDate = (name, value) => {
    setFilterForm({ ...filterForm, [name]: moment(value).format('YYYY-MM-DD') });
  };

  const handleCancel = () => {
    onToggleModal(null);
    setToggle(false);
  };

  return (
    <Dialog open={toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Location Tracker Log</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid md={12}>
            <Autocomplete
              disablePortal
              id='department'
              disableClearable
              fullWidth
              options={departmentOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Deparment' />}
              size='small'
              value={filterForm?.department}
              onChange={(event, newValue) => {
                setFilterForm({
                  ...filterForm,
                  department: newValue,
                });
              }}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
          <Grid md={12}>
            <Autocomplete
              id='rep_id'
              fullWidth
              disableClearable
              options={repOptions}
              autoComplete
              value={filterForm.rep_id}
              onChange={(event, newValue) => {
                setFilterForm({
                  ...filterForm,
                  rep_id: newValue,
                });
              }}
              renderInput={(params) => <TextField {...params} label='MPR' fullWidth />}
              size='small'
            />
          </Grid>
          <Grid lg={6}>
            <DatePicker
              label='from'
              views={['month', 'day', 'year']}
              value={filterForm?.date_from}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='From' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeDate('date_from', value)}
            />
          </Grid>
          <Grid lg={6}>
            <DatePicker
              label='to'
              views={['month', 'day', 'year']}
              value={filterForm?.date_to}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='To' size='small' fullWidth />}
              onChange={(value) => handleChangeDate('date_to', value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit}>Submit</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
